import React from 'react';
import PropTypes from 'prop-types';
import './Input.css';

const Input = ({
  label,
  id,
  value,
  onChange,
  onPaste,
  onBlur = () => ({}),
  required = false,
  maxLength,
  disabled = false,
  type = 'text',
  dataTest,
  error,
  max,
  min,
  pattern,
  placeholder,
  bottomMarginSizing,
  icon
}) => {
  let className =
    'border-2 border-grey-200 bg-white shadow-sm hover:border-grey-300 focus:border-purple-100 block w-full p-2.5 rounded-sm font-sans text-base font-normal disabled:bg-grey-100 disabled:border-grey-200 disabled:text-grey-400';

  if (Boolean(error)) {
    className = `${className} border-red-100`;
  }
  if (icon) {
    className = `${className} pr-11`;
  }
  //bottomMarginSizing === 1 ? 'mb-4' : bottomMarginSizing === 0 ? 'mb-0' : 'mb-8'

  return (
    <div
      className={`mt-2 ${
        bottomMarginSizing === 1 ? 'mb-4' : label || bottomMarginSizing === 0 ? 'mb-0' : 'mb-8'
      }`}
    >
      {label ? (
        <label
          htmlFor={id}
          className={`block font-sans text-sm font-bold text-grey-400 ${
            error ? 'text-red-100' : ''
          }`}
          data-testid={`${dataTest}-label`}
        >
          {label}
          {required ? <span className={error ? 'text-red-100' : 'text-blue-100'}>*</span> : null}
        </label>
      ) : null}
      <div className="mt-1 relative">
        <input
          name={id}
          id={id}
          className={className}
          value={value}
          onChange={onChange}
          onPaste={onPaste ?? onChange}
          onBlur={onBlur}
          type={type}
          required={required}
          maxLength={maxLength}
          disabled={disabled}
          data-testid={dataTest}
          max={max}
          min={min}
          pattern={pattern}
          placeholder={placeholder}
        />
        {icon ? <div className="absolute top-3 right-3">{icon}</div> : null}
      </div>
      {error ? (
        <small
          data-testid={`${dataTest}-error`}
          className="font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
        >
          {error}
        </small>
      ) : null}
    </div>
  );
};

Input.propTypes = {
  label: PropTypes.string,
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onPaste: PropTypes.func,
  onBlur: PropTypes.func,
  dataTest: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number]),
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  maxLength: PropTypes.number,
  type: PropTypes.string,
  error: PropTypes.string,
  max: PropTypes.string,
  min: PropTypes.string,
  pattern: PropTypes.string,
  placeholder: PropTypes.string,
  bottomMarginSizing: PropTypes.oneOf([1, 0, undefined])
};

export default Input;
